import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel,
} from '@microsoft/signalr';

class SignalRSocket {
  constructor(connection) {
    this.connection = connection;
  }

  async ensureConnected() {
    if (
      this.connection.state === 'Disconnected' ||
      this.connection.state === 'Disconnecting'
    ) {
      await this.connection.start();
    }
  }

  on(event, callback) {
    this.connection.on(event, callback);
  }

  off(event, callback) {
    this.connection.off(event, callback);
  }

  emit(method, ...args) {
    return this.connection.invoke(method, ...args);
  }

  async disconnect() {
    await this.connection.stop();
  }
}

export const connect = (token) => {
  const accessToken = token || localStorage.getItem('token') || '';
  const connection = new HubConnectionBuilder()
    .withUrl('/hubs/notifications', {
      accessTokenFactory: () => accessToken.replace(/^Bearer\s+/i, ''),
      transport: HttpTransportType.WebSockets,
      skipNegotiation: true,
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();

  const socket = new SignalRSocket(connection);
  connection
    .start()
    .catch(() => {
      // swallow initial connection errors; automatic reconnect will retry
    });
  return socket;
};
